<div
    class="gap-4 flex w-full"
    [class.flex-col]="!isFlexRow()"
    [class.sm:flex-row]="isFlexRow()">
    <div
        class="flex-1 max-w-md min-w-[12rem]"
        [class.pl-5]="!isFlexRow()">
        <div class="light-text text-body-2">
            {{ 'description' | transloco }}
        </div>

        <p
            class="text-body-1"
            [class]="isFlexRow() ? 'break-words text-start' : ''">
            {{ description() }}
        </p>
    </div>

    <div
        class="w-40 min-w-[10rem]"
        [class.pl-5]="!isFlexRow()">
        <div class="light-text text-body-2">
            {{ 'endDate' | transloco }}
        </div>

        <p class="text-body-1">
            @if (scheduledEndDate()) {
                {{ scheduledEndDate()! | translocoDate }}
            } @else {
                {{ 'notDefined' | transloco: { GENDER: 'feminine' } }}
            }
        </p>
    </div>
</div>
